import { useMemo } from 'react';
import { useSelectedStore } from '@/hooks';
import { KeyTextField } from '@prismicio/client';
import {
  filterSliceItemsByLocationSlug,
  showSliceByLocationSlug,
} from '@/utils/locationSlug';

/**
 * Hook to filter the items of a slice by the location_slug.
 */
const useFilteredSliceItemsByLocationSlug = (items: any) => {
  const { store } = useSelectedStore();

  const filteredItems = useMemo(
    () => filterSliceItemsByLocationSlug<any>(items, store?.url_slug),
    [items, store?.url_slug],
  );

  return { filteredItems };
};

const useShowByLocationSlug = (locationSlug?: string | KeyTextField) => {
  const { store } = useSelectedStore();

  const showContent = useMemo(
    () => showSliceByLocationSlug(locationSlug as string, store?.url_slug),
    [locationSlug, store?.url_slug],
  );

  return { showContent };
};

export { useFilteredSliceItemsByLocationSlug, useShowByLocationSlug };
